import React from 'react';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import ProductUpdatesList from './ProductUpdatesList';

export default function ProductUpdates() {
  useDocumentTitle("What's New - Admin");

  return (
    <Page>
      <Header />
      <ProductUpdatesList />
    </Page>
  );
}
